import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/CSS/login.css";

const Login = () => {
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const navigate = useNavigate();

  // Login-funksjon
  const handleLogin = async () => {
    if (!loginEmail || !loginPassword) {
      alert("Please fill in both email and password.");
      return;
    }
  
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/users/login`, {
        email: loginEmail,
        password: loginPassword
      });

        //  Lagre innlogget bruker i localStorage
      localStorage.setItem("loggedInUser", JSON.stringify(response.data));

      // Logg i consolen for å se om brukeren klarte å logge seg inn
      console.log("User signed in");
  
      // Hvis login er OK, gå til feed
      console.log("Login OK:", response.data);
      navigate("/feed");
  
    } catch (error) {
      console.error("Login FAILED:", error.response?.data || error.message);
      console.log("Invalid credentials")
      alert("Login failed: " + (error.response?.data || "Unknown error"));
    }
  };

  // Registreringsfunksjon
  const handleRegistration = async (event) => {
    event.preventDefault();

    const form = event.target;
    const firstName = form.firstName.value;
    const lastName = form.lastName.value;
    const email = form.email.value;
    const password = form.password.value;
    const rePassword = form.rePassword.value;
    const gender = form.gender.value;

    if (firstName.length > 30){
      alert("Firstname can't be longer than 30 characters");
      return;
    }

    if (lastName.length > 30){
      alert("Lastname can't be longer than 30 charaters");
      return;
    }

    if (!firstName || !lastName || !email || !password || !rePassword || !gender) {
      alert("Please fill out all required fields.");
      return;
    }

    if (password !== rePassword) {
      alert("Passwords do not match.");
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/users/register`, {
        firstName,
        lastName,
        email,
        password,
        gender,
      });

      event.target.reset(); // resetter feltene

      console.log(" Registration successful:", response.data);
      alert("Registration successful!");
    } catch (error) {
      console.error(" Registration failed:", error);
      const message =
        error?.response?.data?.message ||
        error?.response?.data ||
        "Unknown error";
      alert("Registration failed: " + message);
    }
  };

return (
  <div id="login"> 
    <main className="main-content">
      <div className="form-wrapper">
        <div className="signup-form">
          <h2>Sign in</h2>
          <form>
            <input
              type="email"
              placeholder="Email"
              value={loginEmail}
              onChange={(e) => setLoginEmail(e.target.value)}
            />
            <input
              type="password"
              placeholder="Password"
              value={loginPassword}
              onChange={(e) => setLoginPassword(e.target.value)}
            />
            <button type="button" onClick={handleLogin}>
              Sign in
            </button>
          </form>
        </div>   
        
    <div className="divider">or</div>


    <div className="registration-form">
      <h2>Create Account</h2>
      <form onSubmit={handleRegistration}>
        <div className="name">
          <input type="text" name="firstName" placeholder="First name" />
          <input type="text" name="lastName" placeholder="Last name" />
        </div>
        <input type="email" name="email" placeholder="Email" />
        <input type="password" name="password" placeholder="Password" />
        <input type="password" name="rePassword" placeholder="Re-Password" />

        <div className="gender-selection">
          <label>Gender:</label>
          <label>
            <input type="radio" name="gender" value="Male" /> Male
          </label>
          <label>
            <input type="radio" name="gender" value="Female" /> Female
          </label>
          <label>
            <input type="radio" name="gender" value="Other" /> Other
          </label>
        </div>

        <button type="submit">Create new account</button>
      </form>
    </div>
  </div>
</main>
    </div>
  );
};

export default Login;
